import { Box } from "@mui/material";
import * as React from "react";

interface IProps {
    title: string;
}

export const MprcSeparatorBarText = ({ title }: IProps) => {
    return (
        <Box
            sx={
                (theme) => ({ ...theme.extended.separatorBarText.root })
            }
        >
            {title}
        </Box>
    );
};
